import { CheckIcon, CopyIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { useState } from "react";

export const CopyUrlBtn = ({ url }: { url: string }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyHandler = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
    } catch (_) {}
  };

  return (
    <CustomButton
      onClick={copyHandler}
      variant="outlined"
      textColor="white"
      customSize="fit"
      type="button"
      startIcon={!isCopied && <CopyIcon />}
      disabled={isCopied}
      sx={{
        borderColor: "white",
        backgroundColor: isCopied ? "rgba(255, 255, 255, 0.15)" : "transparent",
        "&.Mui-disabled": {
          color: "white",
          borderColor: "white",
        },
        "&.Mui-disabled svg": {
          color: "white",
        },
        "&:hover": {
          backgroundColor: "transparent",
          borderColor: "white",
        },
      }}
    >
      {isCopied && <CheckIcon color={"#7DCEA0"} />}
      {isCopied ? "Link Copied" : "Copy Client Link"}
    </CustomButton>
  );
};
